import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getAggregations(date, options = {}) {
    const { forceReload = false } = options

    return axiosIns.get(
      '/v2/eod_closing/aggregations',
      { params: snakecaseKeys({ date, forceReload }) },
    )
  },
  enqueueAggregation(id, date, options = {}) {
    const { forceReload = false, forceRefresh = false } = options

    return axiosIns.get(
      `/v2/eod_closing/aggregations/${id}/enqueue`,
      { params: snakecaseKeys({ date, forceReload, forceRefresh }) },
    )
  },
  getAggregationJobStatus(id, date) {
    return axiosIns.get(
      `/v2/eod_closing/aggregations/${id}/status`,
      { params: { date } },
    )
  },
  getAvailableUsers(id) {
    return axiosIns.get(`/v2/eod_closing/aggregations/${id}/available_users`)
  },
  // 指定 type の集計表を依存順に「リセット→再集計→保存」する一括処理を起動する。
  // バックエンドは container_id または type を受ける。今は type を渡す（互換パス）。
  bulkComplete(type, date) {
    return axiosIns.post(
      '/v2/eod_closing/aggregations/bulk_complete',
      snakecaseKeys({ type, date }),
    )
  },
  // 一括処理の進捗・各集計表の状態を取得する。
  getBulkCompleteStatus(jobId) {
    return axiosIns.get(`/v2/eod_closing/aggregations/bulk_complete/${jobId}`)
  },
}
